import { render, staticRenderFns } from "./configInfo.vue?vue&type=template&id=4aa03934&scoped=true&"
import script from "./configInfo.vue?vue&type=script&lang=js&"
export * from "./configInfo.vue?vue&type=script&lang=js&"
import style0 from "./configInfo.vue?vue&type=style&index=0&id=4aa03934&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4aa03934",
  null
  
)

export default component.exports